import { abortableFetch } from 'abortcontroller-polyfill/dist/cjs-ponyfill'
import * as _isomorphicFetch from 'isomorphic-fetch'

const fetch = (window.AbortController && _isomorphicFetch) || abortableFetch(_isomorphicFetch).fetch

export const sendJSONData = async ({ url, method, data, signal }) =>
  fetch(url, {
    method: method,
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ...data
    }),
    signal
  }).then(response => response.json())

export const sendRawJSONData = async ({ url, method, data, signal }) =>
  fetch(url, {
    method: method,
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
    signal
  }).then(response => response.json())

export const sendJobJSONData = async ({ url, method, data, signal }) =>
  fetch(url, {
    method: method,
    cache: 'no-cache',
    crossDomain: true,
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
    signal
  }).then(response => response.json())

export const getJSONData = async ({ url, signal }) =>
  fetch(url, {
    method: 'GET',
    cache: 'no-cache',
    credentials: 'same-origin', // session/cookie-authed endpoints (no api key)
    headers: {
      'Content-Type': 'application/json'
    },
    signal
  }).then(response => response.json())
